import type { ReactNode } from 'react';

import type { DraggableSection } from '@/pages/Profile/types';
import { BillingItem, ENCOUNTER_TYPES } from '@/types/encounter';

export interface Props {
  billingItem?: BillingItem | null;
  encounterType?: ENCOUNTER_TYPES;
}

/**
 * One card of the encounter view, in one place: what it is called, whether this
 * encounter has anything to put in it, what sits on its heading row, and what it
 * draws. A card that can render nothing says so through `isUnavailable`, since
 * the section around it draws a heading before the card runs.
 */
export interface EncounterSectionCard extends DraggableSection {
  /** Sits at the right edge of the heading row, e.g. a link out to the full view. */
  actions?: ReactNode;
  render: () => ReactNode;
}

export enum EncounterSection {
  ASK_AI = 'ask-ai',
  AVAILABILITY = 'member-availability',
  BILLING = 'billing',
  CARE_TEAM = 'care-team',
  CHECKLIST = 'provider-checklist',
  CHALLENGE_RESPONSE = 'last-challenge-response',
  CHARTS = 'charts',
  DRUG_SCREEN = 'drug-screen',
  EPISODE_OF_CARE = 'episode-of-care',
  GOAL = 'goal',
  MEDICATIONS = 'medications',
  RECENT_CONTACT = 'recent-contact',
  SCHEDULE = 'next-appointments',
  TAGS = 'tags',
  TASKS = 'tasks'
}
